<template>
  <div class="page-container">
      <label>ED<sup>2</sup> is a web based application for supporting individual Decision-Making and Problem-Solving under conditions of uncertainty and time pressure.
      </label>
      <b-button block variant="primary" @click="selectUsageOption(1)">Decision-Making (quick & less accurate)</b-button>
      <b-button block variant="primary" @click="selectUsageOption(2)">Problem-Solving (less quick & more accurate)</b-button>
</div>
</template>


<script>
import { mapGetters } from 'vuex'
import treePanel from '@/components/treePanel.vue'
import framePanel from '@/components/framePanel.vue'
  import { EventBus } from '@/bus.js';

export default {
  name: 'home',
  components: {
  },
  data: () => ({
  }),
    methods: {
      selectUsageOption(type) {
        this.$store.usageType = type
	      this.$router.push('solver')
        EventBus.$emit('load-tree', 'extra data');
      }
  },

    computed: {

    }
  }
</script>
